import { render } from "./FormRadios.vue?vue&type=template&id=0004d5e4"
import script from "./FormRadios.vue?vue&type=script&lang=js"
export * from "./FormRadios.vue?vue&type=script&lang=js"
script.render = render

export default script